import React from 'react';
import styled from 'styled-components';
import { CHART_NAME_MAX_LENGTH } from '../../../../config/constants';
import { EditableTextInput } from '../../../Form';
import { ChartMode } from '../../types';
import { theme } from '../../../../styles/theme';
import { overflowingStyles } from '../../../../styles/shareableStyles';

interface IProps {
  mode: ChartMode;
  chartTitle: string;
  updateChartTitle?: (display: string) => void;
}

const StaticCompactTitle = styled.div`
  max-width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: inherit;
  ${overflowingStyles};
`;
const StaticLargeTitle = styled.div`
  max-width: 100%;
  font-size: 16px;
  font-weight: 600;
  color: ${theme.colors.secondary900};
  ${overflowingStyles};
`;

const ChartHeaderDisplay = ({ mode, chartTitle, updateChartTitle }: IProps) => {
  if (mode === ChartMode.View || mode === ChartMode.Compact) {
    return <StaticCompactTitle>{chartTitle}</StaticCompactTitle>;
  }

  if (updateChartTitle) {
    return (
      <EditableTextInput
        value={chartTitle}
        onSubmit={updateChartTitle}
        limit={CHART_NAME_MAX_LENGTH}
        inputSize="M"
      />
    );
  }

  return <StaticLargeTitle>{chartTitle}</StaticLargeTitle>;
};

export default ChartHeaderDisplay;
